import { render, staticRenderFns } from "./drawerEmployee.vue?vue&type=template&id=6cb01bb0&"
import script from "./drawerEmployee.vue?vue&type=script&lang=js&"
export * from "./drawerEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports